module.exports = __webpack_public_path__ + "static/media/sqsSa_sm3.21fdba0f.jpeg";